import { createSelector } from 'reselect'

import { PostingRootState } from '../postingRoot.reducer'

export const getGooglePage = createSelector(
  (state: PostingRootState) => state.googleMyBusinessStore.googleMyBusinessPage,
  (state) => state,
)

export const getGooglePageFeeds = createSelector(
  (state: PostingRootState) => state.googleMyBusinessStore.googleFeeds,
  (state) => state,
)
